
import Box from '@mui/material/Box';

import { compare as compareMenu, industries as industriesMenu, products as productsMenu, services as servicesMenu } from './menus';
import NavButton from './NavButton';
import NavListMenu from './NavList';
// Main Navigation Component
export function HeaderDesktopNavMenu({ currentPage, onNavigateToTop }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        fontSize: '0.95rem',
      }}
    >
      <NavButton
        active={currentPage.length === 0}
        onClick={() => onNavigateToTop('/')}
      >
        Home
      </NavButton>

      <NavListMenu
        listMenu={productsMenu}
        listMenuName="Platform"
        currentPage={currentPage}
        onNavigateToTop={onNavigateToTop}
      />

      <NavListMenu
        listMenu={servicesMenu}
        listMenuName="Services"
        currentPage={currentPage}
        onNavigateToTop={onNavigateToTop}
      />

      <NavListMenu
        listMenu={industriesMenu}
        listMenuName="Industries"
        currentPage={currentPage}
        onNavigateToTop={onNavigateToTop}
      />

      <NavListMenu
        listMenu={compareMenu}
        listMenuName="Compare"
        currentPage={currentPage}
        onNavigateToTop={onNavigateToTop}
      />

      <NavButton
        active={currentPage[0] === 'team'}
        onClick={() => onNavigateToTop('/team')}
      >
        Team
      </NavButton>

      {/* Pricing */}
      <NavButton
        active={currentPage[0] === 'pricing'}
        onClick={() => onNavigateToTop('/pricing')}
      >
        Pricing
      </NavButton>

      <NavButton
        active={currentPage[0] === 'security'}
        onClick={() => onNavigateToTop('/security')}
      >
        Security
      </NavButton>

      <NavButton
        active={currentPage[0] === 'contact'}
        onClick={() => onNavigateToTop('/contact')}
      >
        Contact Us
      </NavButton>
    </Box>
  );
}

export default HeaderDesktopNavMenu;
